import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = { class: "date-input-wrapper" }
const _hoisted_3 = { class: "calendar-icon" }
const _hoisted_4 = { class: "slider-container" }
const _hoisted_5 = { class: "slider-value" }
const _hoisted_6 = { class: "taste-buttons" }
const _hoisted_7 = {
  class: "button primary",
  type: "submit"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "loader button-loader"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "loader button-loader"
}

import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { fetchWithAuth } from '@/utils/api';
import { type ExposureLog } from '@/types';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'EditExposureLogForm',
  props: {
    show: { type: Boolean },
    dishId: {},
    logId: {},
    date: {},
    anxiety_level: {},
    taste: {},
    bodys_reaction: {},
    additional_notes: {}
  },
  emits: ["hideForm", "logEdited"],
  setup(__props: any, { emit: __emit }) {

const router = useRouter();

const props = __props;
const emit = __emit;

const store = useStore();
const apiUrl = computed(() => store.getters.getApiUrl);

const exposure_date = ref(props.date);
const anxiety_level = ref(props.anxiety_level);
const taste = ref(props.taste); // "Good", "Okay", or "Bad"
const bodys_reaction = ref(props.bodys_reaction);
const additional_notes = ref(props.additional_notes);
const loading_edit = ref(false);
const loading_delete = ref(false);

const hideForm = () => {
  emit('hideForm');
};

const handleForm = async () => {
  if (!exposure_date.value) {
    alert('Please select a date.');
    return;
  }
  if (!taste.value) {
    alert('Please select a taste option.');
    return;
  }

  const new_log_data: ExposureLog = {
      logId: props.logId,
      date: exposure_date.value,
      anxiety_level: anxiety_level.value,
      taste: taste.value,
      bodys_reaction: bodys_reaction.value,
      additional_notes: additional_notes.value,
    }

  loading_edit.value = true;

  try {
    const response = await fetchWithAuth(
      `${apiUrl.value}/api/logs/${props.logId}`,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(new_log_data),
      },
      store
    );

    if (response.ok) {
      const response_json = await response.json();
      const logId = response_json['logId'];
      new_log_data.id = logId;
      emit('logEdited', new_log_data);
      hideForm();
    } else {
      const errorData = await response.json().catch(() => ({}));
      alert(`Failed to add log: ${errorData.error || 'Unknown error'}`);
    }
    loading_edit.value = false;
  } catch (error) {
    loading_edit.value = false;
    console.error('An error occurred while adding the log:', error);
    alert('An unexpected error occurred. Please try again later.');
  }
};

const deleteExposureLog = async () => {
  if ( confirm("Are you sure that you want to delete this exposure log?")) {
      loading_delete.value = true;
      try {
      const response = await fetchWithAuth(
        `${apiUrl.value}/api/logs/${props.logId}`,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
          }
        },
        store
      );

      if (response.ok) {
        router.push('/dish/'+props.dishId); 
      } else {
        const errorData = await response.json().catch(() => ({}));
        alert(`Failed to delete dish: ${errorData.error || 'Unknown error'}`);
      }
    } catch (error) {
      console.error('An error occurred while deleting the dish:', error);
      alert('An unexpected error occurred. Please try again later.');
    }

  }
}

const isHiding = ref(false);

watch(() => props.show, (newVal) => {
  if (!newVal) {
    isHiding.value = true;
    setTimeout(() => {
      isHiding.value = false;
    }, 300); // Match your transition time (0.3s)
  }
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["add-dish-form-container slide-up-form", { show: _ctx.show, hiding: isHiding.value }])
  }, [
    _createElementVNode("form", {
      id: "add-dish-form",
      onSubmit: _withModifiers(handleForm, ["prevent"])
    }, [
      _createElementVNode("div", null, [
        _cache[7] || (_cache[7] = _createElementVNode("p", null, "Edit Exposure Log", -1)),
        _createElementVNode("button", {
          type: "button",
          onClick: hideForm,
          class: "button secondary",
          id: "close_form_button"
        }, [
          _createVNode(_component_font_awesome_icon, { icon: ['fas', 'xmark'] })
        ])
      ]),
      _createElementVNode("div", _hoisted_1, [
        _cache[8] || (_cache[8] = _createElementVNode("label", { for: "exposure-date-input" }, "Date", -1)),
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            id: "exposure-date-input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((exposure_date).value = $event)),
            type: "date",
            required: ""
          }, null, 512), [
            [_vModelText, exposure_date.value]
          ]),
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'calendar-alt'] })
          ])
        ]),
        _cache[9] || (_cache[9] = _createElementVNode("small", { class: "input-hint" }, "Tap to select a date", -1))
      ]),
      _cache[10] || (_cache[10] = _createElementVNode("label", { for: "anxiety_level" }, "Anxiety Level (1-10)", -1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(anxiety_level.value), 1),
        _withDirectives(_createElementVNode("input", {
          id: "anxiety_level",
          type: "range",
          min: "1",
          max: "10",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((anxiety_level).value = $event))
        }, null, 512), [
          [
            _vModelText,
            anxiety_level.value,
            void 0,
            { number: true }
          ]
        ])
      ]),
      _cache[11] || (_cache[11] = _createElementVNode("label", null, "Taste", -1)),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass({ selected: taste.value === 'Good' }),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (taste.value = 'Good'))
        }, "Good", 2),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass({ selected: taste.value === 'Okay' }),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (taste.value = 'Okay'))
        }, "Okay", 2),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass({ selected: taste.value === 'Bad' }),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (taste.value = 'Bad'))
        }, "Bad", 2)
      ]),
      _cache[12] || (_cache[12] = _createElementVNode("label", { for: "notes" }, "Bodys Reaction", -1)),
      _withDirectives(_createElementVNode("textarea", {
        id: "bodys_reaction_notes",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((bodys_reaction).value = $event)),
        placeholder: "How did your body react to the exposure?",
        maxlength: "500"
      }, null, 512), [
        [_vModelText, bodys_reaction.value]
      ]),
      _cache[13] || (_cache[13] = _createElementVNode("label", { for: "notes" }, "Additional Notes", -1)),
      _withDirectives(_createElementVNode("textarea", {
        id: "additional_notes",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((additional_notes).value = $event)),
        placeholder: "Do you have any additional thoughts?",
        maxlength: "500"
      }, null, 512), [
        [_vModelText, additional_notes.value]
      ]),
      _createElementVNode("button", _hoisted_7, [
        (!loading_edit.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Edit log"))
          : _createCommentVNode("", true),
        (loading_edit.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("button", {
        class: "button danger delete_dish_button",
        type: "button",
        onClick: deleteExposureLog
      }, [
        (!loading_delete.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Delete log"))
          : _createCommentVNode("", true),
        (loading_delete.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_11))
          : _createCommentVNode("", true)
      ])
    ], 32)
  ], 2))
}
}

})